const categoryInitialState = {
  categoryData: undefined,
  loading: false,
  error: null,
  ua: undefined,
  categorySlug: null,
};

export default categoryInitialState;
